export const EDITOR_TABS = [
  { id: "details", label: "Campaign Details" },
  { id: "questions", label: "Survey Questions" },
  { id: "recipients", label: "Recipients" },
  { id: "delivery", label: "Delivery Settings" },
];

export const questionTextErrorKey = (index) => `question-${index}-text`;
export const questionOptionsErrorKey = (index) => `question-${index}-options`;

export const isQuestionErrorKey = (key) => key === "questions" || key.startsWith("question-");

const CHOICE_TYPES = ["single_choice", "multiple_choice"];

export const isChoiceQuestion = (question) => CHOICE_TYPES.includes(question.type);

/**
 * Validates every editor section at once.
 * Returns a map of error key → message; keys map to tabs through `errorTab`.
 */
export const validateCampaign = (formData) => {
  const errors = {};

  if (!formData.name.trim()) {
    errors.name = "Campaign name is required";
  }

  if (formData.questions.length === 0) {
    errors.questions = "At least one question is required";
  }

  formData.questions.forEach((question, index) => {
    if (!(question.text || "").trim()) {
      errors[questionTextErrorKey(index)] = "Question text is required";
    }
    if (
      isChoiceQuestion(question) &&
      (!question.options || question.options.filter((o) => o && o.trim()).length < 2)
    ) {
      errors[questionOptionsErrorKey(index)] = "Choice questions need at least 2 options";
    }
  });

  return errors;
};

const errorTab = (key) => (isQuestionErrorKey(key) ? "questions" : "details");

/** First tab (in tab order) that holds at least one error, or undefined. */
export const firstErrorTab = (errors) => {
  const tabsWithErrors = new Set(Object.keys(errors).map(errorTab));
  return EDITOR_TABS.find((tab) => tabsWithErrors.has(tab.id))?.id;
};
